/* eslint-disable */
require('./add-icon')
require('./arrow_down')
require('./arrow_up')
require('./blackList-btn')
require('./computer')
require('./connect')
require('./cut')
require('./delete-icon')
require('./delete')
require('./edit-icon')
require('./icon-comment-success')
require('./icon-comment')
require('./icon-connect')
require('./icon-customer-service')
require('./icon-emoji')
require('./icon-evaluate')
require('./icon-file')
require('./icon-image')
require('./icon-new-channel')
require('./icon-no-img')
require('./icon-screentshot')
require('./icon-transfer-conversation')
require('./person')
require('./phone')
require('./prohibit')
require('./star-btn')
require('./star-show')
require('./stastic-avatar')
